import { action, makeObservable, observable } from 'mobx';

import { IUserModel, UserModel } from 'shared/models';
import { ModelArrayCast } from "shared/casts";

import { Model } from './Model';

export interface ICompanyBestGroupModel {
    id?: number;
    name?: string;
    users?: IUserModel[];
}

export class CompanyBestGroupModel extends Model implements ICompanyBestGroupModel {
    casts = {
        users: new ModelArrayCast(UserModel),
    };

    id = 0;
    name = '';
    users: UserModel[] = [];

    constructor(payload: ICompanyBestGroupModel = {}) {
        super();

        makeObservable(this, {
            id: observable,
            name: observable,
            users: observable,
            update: action,
        });

        this.update(payload);
    }
}
